import { useReducer, useState } from "react";
import {
  Box,
  Divider,
  FormLabel,
  // OutlinedInput,
  Stack,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { useDispatch } from "react-redux";
import base from "../../../api/apis";
import { MuiTelInput } from "mui-tel-input";
import { toast } from "react-toastify";
// import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
// import moment from "moment";

const InputField = styled(TextField)(({ theme }) => ({
  borderRadius: "8px",
}));

const ContactAgent = ({
  agent_id,
  agentName,
  notePlaceholder = "Write message here",
  onClose = () => {},
}) => {
  const modalDispatch = useDispatch();
  const [load, setLoad] = useState(false);
  const [value, setValue] = useState("");

  const formState = {
    name: "",
    email: "",
    phone: "",
    // preferredMove: "",
    message: "",
  };

  const formReducer = (state, action) => {
    switch (action.type) {
      case "NAME":
        return { ...state, name: action.payload };
      case "PHONE":
        return { ...state, phone: action.payload };
      case "EMAIL":
        return { ...state, email: action.payload };
      // case "PREFERREDMOVE":
      //   return { ...state, preferredMove: action.payload };
      case "MSG":
        return { ...state, message: action.payload };
      case "RESET":
        return formState;
      default:
        return state;
    }
  };

  const [formInput, dispatch] = useReducer(formReducer, formState);

  const onFormSubmit = async (e) => {
    e.preventDefault();

    if (!formInput.name || !formInput.email.includes("@") || !formInput.phone) {
      // modalDispatch({
      //   type: "ERROR",
      //   payload: "Check that required fields are not empty",
      // });
      toast.error("Check that required fields are not empty");
      return;
    }
    setLoad(true);

    const body = {
      client_name: formInput.name,
      client_email: formInput.email,
      client_phone: formInput.phone,
      client_message: formInput.message,
      // preferred_move: formInput.preferredMove,
      agent_id,
      source_url: window?.location?.href,
    };

    try {
      const res = await base.post("register/contact_agent/", body);
      if (res) {
        // Reset form
        dispatch({ type: "RESET" });
        setValue("");

        setLoad(false);
        modalDispatch({ type: "SUCCESS", payload: res.data });
        onClose();
      }
    } catch (error) {
      // modalDispatch({
      //   type: "ERROR",
      //   payload: "Sorry, something went wrong",
      // });
      toast.error("Sorry, something went wrong");
      setLoad(false);
    }
  };

  const handleChange = (newValue) => {
    setValue(newValue);
    dispatch({ type: "PHONE", payload: newValue });
  };

  return (
    <Box width="100%" sx={{ "& *": { fontFamily: "Galano Grotesque Alt" } }}>
      <form
        id="contact-agent"
        sx={{ padding: "0 1.5rem 1.5rem 1.5rem", overflowX: "hidden" }}
      >
        <Typography variant="h6">Contact {agentName ?? "Agent"}</Typography>
        {/* <Typography variant="body2" noWrap>
          We are collecting your information to pass along to the property
          manager
        </Typography> */}

        <Stack
          gap={2}
          mt={2}
          sx={{
            "& .MuiFormLabel-root": { fontSize: "14px" },
            "& input": { fontSize: "16px" },
          }}
        >
          <Stack gap={1}>
            <FormLabel>Name *</FormLabel>
            <InputField
              variant="outlined"
              value={formInput.name}
              required
              fullWidth
              size="small"
              placeholder="Enter your name"
              onChange={(e) =>
                dispatch({
                  type: "NAME",
                  payload: e.target.value,
                })
              }
            />
          </Stack>
          <Stack gap={1}>
            <FormLabel>Phone</FormLabel>
            <MuiTelInput
              defaultCountry="US"
              size="small"
              placeholder="Enter your phone number"
              value={value}
              fullWidth
              sx={{
                borderRadius: "8px",
              }}
              onChange={handleChange}
            />
          </Stack>
          <Stack gap={1}>
            <FormLabel>Email address *</FormLabel>
            <InputField
              variant="outlined"
              type={"email"}
              size="small"
              value={formInput.email}
              required
              onChange={(e) =>
                dispatch({ type: "EMAIL", payload: e.target.value })
              }
              fullWidth
              placeholder="Enter your email"
            />
          </Stack>
          {/* <Stack gap={1}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <FormLabel>Preferred Move In Date (optional)</FormLabel>
              <DateTimePicker
                name="preferredMove"
                sx={{
                  fontSize: "16px",
                  height: "44px",
                  "& input": { padding: "8.50px 14px !important" },
                }}
                value={
                  formInput.preferredMove
                    ? moment(formInput.preferredMove)
                    : null
                }
                onChange={(val) => {
                  if (val)
                    dispatch({
                      type: "PREFERREDMOVE",
                      payload: val?.toDate()?.toISOString(),
                    });
                }}
                renderInput={(params) => (
                  <OutlinedInput
                    size="normal"
                    inputProps={{
                      style: {
                        fontSize: "16px",
                      },
                    }}
                    sx={{
                      fontSize: "16px",
                      borderColor: "black",
                      marginRight: "16px",
                    }}
                    {...params}
                    helperText={null}
                  />
                )}
                minDateTime={moment(new Date())}
              />
            </LocalizationProvider>
          </Stack> */}
          <Stack gap={1}>
            <FormLabel>Note/Message (Optional)</FormLabel>
            <InputField
              variant="outlined"
              multiline
              rows={4}
              value={formInput.message}
              onChange={(e) =>
                dispatch({ type: "MSG", payload: e.target.value })
              }
              fullWidth
              placeholder={notePlaceholder}
            />
          </Stack>
          <Stack mt={0.5} gap={3}>
            <LoadingButton
              loading={load}
              onClick={onFormSubmit}
              disabled={load}
              size="large"
              color="primary"
              variant="contained"
              type="submit"
              disableElevation
              fullWidth
              sx={{
                borderRadius: 999,
                height: "48px",
              }}
            >
              <Typography variant="body" fontWeight={400}>
                Submit
              </Typography>
            </LoadingButton>

            <Stack width="100%" gap={2.5}>
              <Divider>
                <Typography variant="body4" sx={{ color: "primary.Gray.200" }}>
                  OR
                </Typography>
              </Divider>

              <Typography
                variant="regularMedium"
                component={"a"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  textAlign: "center",
                  color: "button.link",
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
                href="tel:+18886165270"
              >
                <LocalPhoneIcon color="primary" />
                (1-888-616-5270)
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </form>
    </Box>
  );
};

export default ContactAgent;
